import cn from 'classnames';
import { useEffect, useState } from 'react';
import { generatePath } from 'react-router';
import { useHistory } from 'react-router-dom';
import Button from 'components/form/Button';
import Icon from 'components/Icon';
import { PiiTypeList } from 'components/PiiType';
import Preloader from 'components/Preloader';
import GridBody from 'components/table/GridBody';
import GridCell from 'components/table/GridCell';
import GridHead from 'components/table/GridHead';
import GridRow from 'components/table/GridRow';
import GridTable from 'components/table/GridTable';
import { Typo } from 'components/typography/Typo';
import { KafkaInstanceItem } from 'models/kafkaInstances/dto';
import { getKafkaTopicList } from 'models/kafkaTopics/api';
import { KafkaTopicItem } from 'models/kafkaTopics/dto';
import { PATHS } from 'services/router';
import { unselectInteractsWith } from '../../model/store';
import commonStyles from '../index.module.css';
import styles from './index.module.pcss';

type Props = {
	kafkaInstanceId: KafkaInstanceItem['id'];
};

function Topics({ kafkaInstanceId }: Props) {
	const [topicList, setTopicList] = useState<KafkaTopicItem[]>([]);
	const [loading, setLoading] = useState(false);
	const history = useHistory();

	useEffect(() => {
		setLoading(true);

		getKafkaTopicList({
			'instance-ids': kafkaInstanceId,
			limit: 100,
			offset: 0,
		})
			.then(({ topics }) => setTopicList(topics))
			.catch((error) => {
				console.error('Failed to fetch Kafka topics:', error);
			})
			.finally(() => {
				setLoading(false);
			});

		return unselectInteractsWith;
	}, [kafkaInstanceId]);

	return (
		<div className={commonStyles.detailsContainer}>
			<Preloader isLoading={loading}>
				<div className={cn(commonStyles.sidePaddings, commonStyles.scrollContainer)}>
					<GridTable className={commonStyles.table}>
						<GridHead>
							<GridRow className={cn(styles.dataflowRowContainer, styles.gridHeaderRow)} border>
								<GridCell head className={styles.gridCellHead}>
									name
								</GridCell>

								<GridCell head className={styles.gridCellHead}>
									data types
								</GridCell>
							</GridRow>
						</GridHead>

						<GridBody className={styles.tableBody}>
							{topicList.map(({ name, data_types, id }, i) => {
								return (
									<GridRow
										data-test="kafka-details-topic-row"
										key={i}
										className={styles.dataflowRowContainer}
										onClick={() => {
											const path = generatePath(PATHS.KAFKA_TOPICS_ITEM, {
												id,
											});
											history.push(path);
										}}
										border
										hover
									>
										<GridCell className={styles.gapCell}>
											<Typo variant="D/Medium/Meta">{name}</Typo>
										</GridCell>

										<GridCell>
											<PiiTypeList noHighlight data={data_types} size="extraSmall" />
										</GridCell>
									</GridRow>
								);
							})}
						</GridBody>

						<Button
							color="tertiary"
							size="small"
							endIcon={<Icon name="Open/Regular" size={20} />}
							fullWidth
							href={generatePath(`${PATHS.KAFKA_TOPICS}?instance-ids=${kafkaInstanceId}`)}
							target="_blank"
							className={styles.detailedInfo}
						>
							View detailed info
						</Button>
					</GridTable>
				</div>
			</Preloader>
		</div>
	);
}

export default Topics;
